export const COUNTRY_CODE = 'US';

//   W, S, E, N
//   'US': ('United States', (-171.791110603, 18.91619, -66.96466, 71.3577635769)),
// export const COUNTRY_BOUNDS = {
//   south: 18.91619,
//   west: -171.791110603,
//   north: 71.3577635769,
//   east: -66.96466,
// };

// export const COUNTRY_BOUNDS = {
//   south: 18.91619,
//   west: -171.791110603,
//   north: 71.3577635769,
//   east: -16.96466,
// };

//   W, S, E, N
//   'Sacramento': ( (-121.565766, 38.442295, -121.368386, 38.690211)),
//westlimit=-124.48; southlimit=32.53; eastlimit=-108.06; northlimit=42.01
export const COUNTRY_BOUNDS = {
  south: 32.53,
  west: -124.48,
  north: 42.01,
  east: -108.06,
};
export const MAP_CENTER = {
  lat: (COUNTRY_BOUNDS.north + COUNTRY_BOUNDS.south) / 2,
  lng: (COUNTRY_BOUNDS.west + COUNTRY_BOUNDS.east) / 2,
  // lat: 38.575764,
  // lng: -121.478851,
};

export const DEFAULT_LOCATION = {
  ...COUNTRY_BOUNDS,
  ...MAP_CENTER,
  formatted_address: 'USA',
  place_id: null,
  zoom: 5,
};
